<template>
    <v-app>
        <v-container class="services">
            <v-layout xs8 md12 class="title-block">
                <v-flex>
                    <h2>Проверка и восстановление КБМ</h2>
                </v-flex>
            </v-layout>
            <services-carousel
                :slides="carouselSlides"
            />
        </v-container>
        <v-container class="services">
            <services-kbm-request-form
                :hasResult = "hasResult"
                :requestResult = "requestResult"
                :loading = "loading"
                @find = "find"
            />
        </v-container>
        <services-underlist />
        <services-list />
    </v-app>
</template>
<script>
    import _ from 'lodash';

    export default {
        data: () => ({
            loading: false,
            hasResult: false,
            requestResult: {
                requestInfo: null,
                fio: null,
                date: null,
                kbm: null,
                lossDates: null,
                link: null,
            },
            requestResultDefault: {},
            carouselSlides: [
                'Проверьте историю КБМ за 10 лет.',
                'Восстановите свою скидку по ОСАГО, чтобы меньше платить за полис.',
                'Мы вернем деньги, если КБМ не изменится.'
            ],
        }),
        created() {
            this.requestResultDefault = _.cloneDeep(this.requestResult)
        },
        methods: {

            resetResult() {
                this.requestResult = _.cloneDeep(this.requestResultDefault)
                this.showMore = false
                this.hasResult = false
                window.scrollTo(0,0);
            },

            find(data) {
                this.loading = true;

                try {
                    grecaptcha.ready(() => {
                        grecaptcha.execute(
                            Vue.GetpolisConstants.RECAPTCHA_SITEKEY,
                            {action: Vue.GetpolisConstants.RECAPTCHA_ACTIONS.KBM}
                        ).then(token => {
                            data.r = token
                            axios.post('/services/getkbm', data)
                            .then(response => {
                                this.hasResult = true
                                this.requestResult = response.data
                            })
                            .catch(error => {
                                console.log(error);
                                PNotify.error('Не удалось получить данные по КБМ.');
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                        });
                    })
                } catch (e) {
                    console.log(e);
                }
            }
        }
    }
</script>
<style>
    .v-responsive.v-image.v-carousel__item {
        min-height: 60px;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/services/ServiceKbmPage.vue